/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// @ts-nocheck

import { customElement } from 'lit/decorators.js';

import { styles as primaryStyles } from '@material/web/tabs/internal/primary-tab-styles.js';
import { styles as sharedStyles } from '@material/web/tabs/internal/tab-styles.js';
import { PrimaryTab } from './internal/primary-tab.js';

/* declare global {
  interface HTMLElementTagNameMap {
    'md-primary-tab': MdPrimaryTab;
  }
} */

// TODO(b/267336507): add docs
/**
 * @summary Tab allow users to display a tab within a Tabs.
 *
 */
@customElement('md-primary-tab')
export class MdPrimaryTab extends PrimaryTab {
  static override styles = [sharedStyles, primaryStyles];
}
